// extracted by mini-css-extract-plugin
export var double = "ComponentTextMedia-module--double--6abaa";
export var h2 = "ComponentTextMedia-module--h2--01696";
export var h2Center = "ComponentTextMedia-module--h2Center--b21bc";
export var h3 = "ComponentTextMedia-module--h3--96761";
export var h3Center = "ComponentTextMedia-module--h3Center--57f81";
export var h4 = "ComponentTextMedia-module--h4--b5856";
export var h4Center = "ComponentTextMedia-module--h4Center--aa466";
export var image = "ComponentTextMedia-module--image--22aac";
export var link = "ComponentTextMedia-module--link--f9fbb";
export var linkCenter = "ComponentTextMedia-module--linkCenter--66e9d";
export var logoInBackground = "ComponentTextMedia-module--logoInBackground--3e4f2";
export var media = "ComponentTextMedia-module--media--06a3d";
export var mediaText = "ComponentTextMedia-module--mediaText--29775";
export var p = "ComponentTextMedia-module--p--96a52";
export var pCenter = "ComponentTextMedia-module--pCenter--b90c8";
export var section = "ComponentTextMedia-module--section--934e9";
export var single = "ComponentTextMedia-module--single--ef800";
export var sticky = "ComponentTextMedia-module--sticky--3ebd8";
export var text = "ComponentTextMedia-module--text--c2f8b";
export var textMedia = "ComponentTextMedia-module--textMedia--8550d";
export var video = "ComponentTextMedia-module--video--83804";